module.exports = __webpack_public_path__ + "img/lady_gaga_chromatica.9c87e668.jpg";